import React, { useState, KeyboardEvent } from 'react';
import { X, Plus } from 'lucide-react';

interface ChipsInputProps {
  value: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  className?: string;
}

export const ChipsInput: React.FC<ChipsInputProps> = ({
  value = [],
  onChange,
  placeholder = 'Přidat...',
  className = '',
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag();
    } else if (e.key === 'Backspace' && !inputValue && value.length > 0) {
      removeTag(value.length - 1);
    }
  };

  const addTag = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !value.includes(trimmed)) {
      onChange([...value, trimmed]);
      setInputValue('');
    }
  };

  const removeTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div
      className={`flex flex-wrap gap-2 p-2 bg-white/50 dark:bg-zinc-800/50 border border-gray-200 dark:border-zinc-700 rounded-lg focus-within:ring-2 focus-within:ring-green-500/20 focus-within:border-green-500 transition-all ${className}`}
    >
      {value.map((tag, index) => (
        <span
          key={index}
          className="flex items-center gap-1 bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300 px-2 py-1 rounded text-xs font-medium border border-green-200 dark:border-green-800"
        >
          {tag}
          <button
            type="button"
            onClick={() => removeTag(index)}
            aria-label="Odebrat"
            className="hover:bg-green-200 dark:hover:bg-green-800 rounded-full p-0.5 transition-colors"
          >
            <X size={12} />
          </button>
        </span>
      ))}
      <div className="flex-1 min-w-[120px] flex items-center">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={addTag}
          className="w-full bg-transparent outline-none text-sm text-gray-900 dark:text-zinc-100 placeholder-gray-500 dark:placeholder-zinc-400"
          placeholder={value.length === 0 ? placeholder : ''}
        />
        {inputValue && (
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault();
              addTag();
            }}
            title="Přidat štítek"
            className="text-green-600 hover:text-green-700"
          >
            <Plus size={16} />
          </button>
        )}
      </div>
    </div>
  );
};
